export const COMPANY = {
  name: "Ramo Advisors LLC",
  tagline: "Protecting Capital. Managing Risk. Guiding Execution.",
  email: "sead@ramoinc.com",
  phone: "(201) 600-7622",
  phoneRaw: "+12016007622",
  serviceArea: ["New Jersey", "New York", "Remote Consulting Nationwide"],
  logo: "https://customer-assets.emergentagent.com/job_ramo-advisory/artifacts/30nxw1fo_ramo-advisors-llc-high-resolution-logo-transparent.png",
};

export const NAV_ITEMS = [
  { label: "Services", id: "services" },
  { label: "Why Us", id: "why-us" },
  { label: "Who We Serve", id: "who-we-serve" },
  { label: "Process", id: "process" },
  { label: "Contact", id: "contact" },
];

export const SERVICES = [
  {
    title: "Owner's Representation",
    icon: "ShieldCheck",
    description:
      "Representing ownership interests through planning, oversight, stakeholder coordination, budget accountability, and project guidance.",
  },
  {
    title: "Risk Management Consulting",
    icon: "AlertTriangle",
    description:
      "Identifying, evaluating, and mitigating operational, financial, contractual, and project-related risks before they become costly issues.",
  },
  {
    title: "Real Estate Development Advisory",
    icon: "Building2",
    description:
      "Strategic guidance throughout the development lifecycle — planning, feasibility reviews, execution strategy, and project evaluation.",
  },
  {
    title: "Project Oversight",
    icon: "ClipboardCheck",
    description:
      "Independent monitoring of project performance, schedules, budgets, and stakeholder accountability.",
  },
  {
    title: "Due Diligence",
    icon: "FileSearch",
    description:
      "Helping clients evaluate development opportunities, acquisitions, project viability, and potential risks before capital is committed.",
  },
  {
    title: "Insurance & Risk Strategy",
    icon: "Umbrella",
    description:
      "Evaluating insurance requirements, contractual risk transfer provisions, and risk allocation strategies to help clients identify potential exposures and strengthen project outcomes.",
  },
];

export const WHY_US = [
  {
    title: "Independent Perspective",
    description: "Objective guidance focused entirely on protecting client interests.",
  },
  {
    title: "Risk-First Approach",
    description: "Every recommendation begins with identifying and mitigating risk.",
  },
  {
    title: "Real-World Experience",
    description:
      "Built on practical knowledge of construction operations, development processes, procurement, and project execution.",
  },
  {
    title: "Actionable Solutions",
    description: "Recommendations designed for implementation — not theoretical consulting reports.",
  },
];

export const CLIENTS = [
  "Real Estate Developers",
  "Commercial Property Owners",
  "Residential Developers",
  "Real Estate Investors",
  "General Contractors",
  "Construction Managers",
  "Family Offices",
  "Private Equity Investors",
];

export const PROCESS = [
  { step: "01", title: "Assess", description: "Identify project objectives, risks, and opportunities." },
  { step: "02", title: "Analyze", description: "Evaluate constraints, exposures, and areas for improvement." },
  { step: "03", title: "Strategize", description: "Develop practical recommendations and action plans." },
  { step: "04", title: "Guide", description: "Provide ongoing advisory support and oversight." },
];

export const IMAGES = {
  hero:
    "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=2000&q=80",
  blueprint:
    "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1800&q=80",
  handshake:
    "https://images.unsplash.com/photo-1664575601711-67110e027b9b?auto=format&fit=crop&w=1800&q=80",
  skyline:
    "https://images.unsplash.com/photo-1486325212027-8081e485255e?auto=format&fit=crop&w=1800&q=80",
};
